import Header from './header.js';
import Footer from './footer.js';
import '../styles/layout.css';

const Layout = ({ children }) => {

    return (
        <div className="layout">
            <Header />
            <>{children}</>
            <Footer />
        </div>
    );
};

export default Layout;
